import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './authSlice';
import { writeAuthSession } from './authSession';

export const store = configureStore({
  reducer: {
    auth: authReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

let persisted = JSON.stringify(sessionOf());

/**
 * Keep the stored session in step with the store.
 *
 * `mode` is part of it, and dropping it is not a cosmetic omission: logging in
 * does a full page load, so whatever is written here is the whole of what the
 * app knows about itself afterwards. A session persisted without its mode came
 * back as a bearer session holding a placeholder token, which the client then
 * tried to refresh against an identity service that never issued it — and the
 * user was bounced straight back to the login screen they had just used.
 */
store.subscribe(() => {
  const session = sessionOf();
  const next = JSON.stringify(session);
  if (next === persisted) return;
  persisted = next;
  writeAuthSession(session);
});

function sessionOf() {
  const { accessToken, refreshToken } = store.getState().auth;
  return accessToken && refreshToken ? { accessToken, refreshToken } : null;
}
